module.exports = __webpack_public_path__ + "static/media/bg_map.a4c66544.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bg_map.png
// module id = 531
// module chunks = 0